<template>
  <RouterView />
  <PrimeLocale />
  <Toast v-if="props.enableToast" />
</template>

<script setup lang="ts">
import { useUiStore } from "@common/stores";
import { PrimeLocale } from "@common/ui/atoms/Misc/PrimeLocale";
import type { Link } from "@unhead/vue";
import { useHead } from "@unhead/vue";
import { storeToRefs } from "pinia";
import Toast from "primevue/toast";
import type { PropType } from "vue";
import { computed } from "vue";

// Props
const props = defineProps({
  enableToast: {
    type: Boolean,
    required: false,
  },
  darkLinks: {
    type: Array as PropType<Link<any | undefined>[]>,
    required: false,
  },
  lightLinks: {
    type: Array as PropType<Link<any | undefined>[]>,
    required: false,
  },
});

// Variables
const uiStore = storeToRefs(useUiStore());

// Computed
const linksComputed = computed(() => {
  return uiStore.themeScheme.value === "light" ? props.lightLinks : props.darkLinks;
});

// Hooks
useHead({
  htmlAttrs: {
    class: uiStore.themeScheme,
  },
  link: linksComputed as any,
});
</script>
